import type {
  ActionPerformed,
  // PushNotificationSchema,
  Token,
} from '@capacitor/push-notifications'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import axios from 'axios'
import router from '@/router'
import { useAppStore } from '@/stores/app'

export default {
  async requestPermissions() {
    if (!Capacitor.isNativePlatform()) return

    let permStatus = await PushNotifications.checkPermissions()

    if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
      permStatus = await PushNotifications.requestPermissions()
    }

    if (permStatus.receive !== 'granted') {
      return
    }

    await PushNotifications.register()
  },
}

if (Capacitor.isNativePlatform()) {
  PushNotifications.addListener('registration', (token: Token) => {
    axios
      .post('/auth/register-device', { token: token.value, platform: Capacitor.getPlatform() })
      .catch((e) => e)
  })

  PushNotifications.addListener('registrationError', (error: any) => {
    useAppStore().addError('Error on registration: ' + JSON.stringify(error))
  })

  // Method called when tapping on a notification
  PushNotifications.addListener('pushNotificationActionPerformed', (payload: ActionPerformed) => {
    const url = payload.notification.data?.url
    if (!url) return

    const path = new URL(url).pathname
    router.push(path).catch((e) => e)
  })
}
